import { TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
var RepresentanteComponent = /** @class */ (function () {
    function RepresentanteComponent(fb, _userService, rutValidator, dialog, spinner) {
        this.fb = fb;
        this._userService = _userService;
        this.dialog = dialog;
        this.spinner = spinner;
        this.rows = [];
        this.matcher = new FormService();
        this.nombreComuna = new FormControl('', [Validators.required]);
        this.options = [];
        this.selectedRep = null;
        this.regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        this.rut_rep = this.fb.group({
            rut: ['', [Validators.required, rutValidator]]
        });
        this.mail_rep = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        });
        if (!JSON.parse(localStorage.getItem("representantes"))) {
            localStorage.setItem("representantes", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("representantes"));
            //console.log(this.rows)
        }
        this.invalidRut = true;
        this.representante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
    }
    RepresentanteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getComunas();
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    RepresentanteComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.options.filter(function (option) { return option.toLowerCase().includes(filterValue); });
    };
    RepresentanteComponent.prototype.get_representante = function (rut) {
        var _this = this;
        window.scroll(0, 0);
        this.spinner.show();
        this.cleanData();
        this._userService.getRepresentante(rut).subscribe(function (response) {
            if (response.message) {
                _this.representante.rut = rut ? rut : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
            else {
                _this.representante.rut = response.rut ? response.rut : '';
                _this.representante.nombre = response.nombre ? response.nombre : '';
                _this.representante.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                _this.representante.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                _this.representante.direccion = response.direccion ? response.direccion : '';
                _this.representante.direccion_num = response.direccion_num ? response.direccion_num : '';
                _this.representante.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                _this.representante.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                _this.representante.comuna = response.comuna ? response.comuna : '';
                _this.representante.fono = response.fono ? response.fono : '';
                _this.representante.mail = response.mail ? response.mail : '';
                _this.representante.recordId = response.recordId ? response.recordId : '';
                _this.spinner.hide();
                _this.dialog.open(_this.openModal);
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    RepresentanteComponent.prototype.cleanData = function () {
        this.representante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
        this.rut_rep.reset();
    };
    RepresentanteComponent.prototype.update_representante = function (rut, id) {
        this.get_representante(rut);
        this.selectedRep = id;
    };
    RepresentanteComponent.prototype.saveRepresentante = function () {
        var _this = this;
        window.scroll(0, 0);
        //por si escriben un rut que ya esté ingresado
        for (var x = 0; x < this.rows.length; x++) {
            if (this.representante.rut == this.rows[x].rut) {
                this.delete_representante(x);
            }
        }
        //elimina fila cuando la editan
        /*if (this.selectedRep != null) {
            this.delete_representante(this.selectedRep);
            this.selectedRep = null;
        }*/
        this.spinner.show();
        this._userService.saveRepresentante(this.representante).subscribe(function (response) {
            _this.spinner.hide();
            console.log(response);
            if (response.update || response.save) {
                $("#rep_modal").modal("hide");
                _this.actualRow = localStorage.getItem("representantes");
                _this.rows = JSON.parse(_this.actualRow);
                _this.rows = _this.rows.concat({
                    rut: _this.representante.rut,
                    nombre: _this.representante.nombre,
                    apellido_pat: _this.representante.apellido_pat,
                    apellido_mat: _this.representante.apellido_mat,
                    direccion: _this.representante.direccion,
                    direccion_num: _this.representante.direccion_num,
                    direccion_complemento: _this.representante.direccion_complemento,
                    direccion_completa: _this.representante.direccion_completa,
                    comuna: _this.representante.comuna,
                    fono: _this.representante.fono,
                    mail: _this.representante.mail
                });
                localStorage.setItem("representantes", JSON.stringify(_this.rows));
                _this.representante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
                _this.rut_rep.reset();
                _this.dialog.closeAll();
            }
        }, function (error) {
            _this.spinner.hide();
            console.log(error);
        });
    };
    RepresentanteComponent.prototype.delete_representante = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("representantes", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('representantes'));
            }
        }
    };
    RepresentanteComponent.prototype.getComunas = function () {
        var _this = this;
        this._userService.getComunas().subscribe(function (res) {
            //console.log('res', res);
            for (var i = 0; i < res.length; i++) {
                _this.options.push(res[i].fieldData.COM_Nombre);
            }
            _this.filteredOptions = _this.nombreComuna.valueChanges
                .pipe(startWith(''), map(function (value) { return _this._filter(value); }));
        }, function (error) {
            console.log(error);
        });
    };
    return RepresentanteComponent;
}());
export { RepresentanteComponent };
